import './App.css';
import { v4 as uuidv4 } from 'uuid';
import { useEffect, useState, useRef } from 'react';
import {
  Widget,
  addResponseMessage,
  addUserMessage,
  toggleWidget,
  toggleMsgLoader,
  dropMessages,
} from 'react-chat-widget';

import 'react-chat-widget/lib/styles.css';
import ReactPlayer from 'react-player';
import axios from 'axios';

let didToken;

function App() {
  if (!localStorage.getItem('customer-uuid')) {
    localStorage.setItem('customer-uuid', uuidv4());
  }
  if (!localStorage.getItem('avatar-customer-uuid')) {
    localStorage.setItem('avatar-customer-uuid', uuidv4());
  }
  const [chatHistory, setChatHistory] = useState();
  const [customerUuid, setcustomerUuid] = useState();
  const [ava, setAva] = useState();
  const [isMicroEnabled, setIsMicroEnabled] = useState();
  const [logo, setLogo] = useState();
  const [video, setVideo] = useState();
  const [play, setPlay] = useState();
  const [animation, setAnimation] = useState();
  const [loop, setLoop] = useState();
  const [image, setImage] = useState();
  const [providerType, setProviderType] = useState();
  const [providerVoiceId, setProviderVoiceId] = useState();
  const [providerStyle, setProviderStyle] = useState();
  const [peer, setPeer] = useState();
  const [strid, setStrid] = useState();
  const [sessionid, setSessionid] = useState();
  const [finishPrepare, setFinishPrepare] = useState(true);
  const [messageText, setmessageText] = useState();
  const isTalk = useRef(false);

  const hostName = window.location.origin;
  // const hostName = 'app.dev.cleverbots.ae';
  const protocol = window.location.protocol;
  // let botUid = '65808893-5a8f-4a77-b63a-d54f817710c4';
  let botUid = 'landing';
  let avatar = false;

  const RTCPeerConnection = (
    window.RTCPeerConnection ||
    window.webkitRTCPeerConnection ||
    window.mozRTCPeerConnection
  ).bind(window);

  let peerConnection;
  let streamId;
  let sessionId;
  let sessionClientAnswer;
  let statsIntervalId;
  let videoIsPlaying;
  let lastBytesReceived;
  const maxRetryCount = 3;
  const maxDelaySec = 4;

  // const didToken = 'YWxleEBjbGV2ZXJib3RzLmFl:NCueWoDC4_aIAxyyNWump';

  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    const paramValue = searchParams.get('avatar');

    if (paramValue == 1) {
      avatar = true;
      setAva(true);
    }
    if (detectBrowser() === 'Safari') {
      navigator.mediaDevices.getUserMedia({ video: true });
    }
  }, []);

  const botData = window.location.pathname.replace(/\/$/, '').split('/').pop();
  if (botData != 'landingWidget') {
    const parsedData = atob(botData).split('|');
    botUid = parsedData[1];
  }

  const getSessionLink = () => {
    return (
      hostName +
      `/api/${avatar ? 'avatar_' : ''}widget/?customer_uuid=${
        avatar
          ? localStorage.getItem('avatar-customer-uuid')
          : localStorage.getItem('customer-uuid')
      }` +
      `&bot_uuid=${botUid}`
    );
  };

  const getMessageLink = () => {
    return hostName + `/api/send_${ava ? 'avatar_' : ''}message/`;
  };

  useEffect(() => {
    toggleWidget();
    toggleMsgLoader();
    axios
      .get(getSessionLink())
      .then((response) => {
        didToken = response.data.did_token;
        document.title = response.data.title;
        setIsMicroEnabled(response.data.is_audio_enabled);
        addResponseMessage(response.data.start_message);
        setProviderType(response.data.voice_provider);
        setProviderVoiceId(response.data.voice_id);
        setProviderStyle(response.data.voice_style);
        setChatHistory(
          response.data.messages.map((item) => {
            addUserMessage(item.question);
            addResponseMessage(item.answer);
          })
        );
        toggleMsgLoader();
        setLogo(response.data.logo_url);
        if (avatar) {
          if (response.data.animation_gif_url) {
            setImage(response.data.animation_gif_url);
          } else {
            setImage(response.data.source_url);
          }
          prepare(response.data.source_url);
          // setInterval(async () => {
          //   prepare(response.data.source_url);
          // }, 1000 * 90);
        }
      })
      .catch((err) => {
        console.log(err);
      });

    if (avatar) {
      setcustomerUuid(localStorage.getItem('avatar-customer-uuid'));
    } else {
      setcustomerUuid(localStorage.getItem('customer-uuid'));
    }
  }, []);

  const handleNewUserMessage = (newMessage) => {
    toggleMsgLoader();

    if (newMessage != '/start') {
      axios
        .post(getMessageLink(), {
          customer_uuid: customerUuid,
          text: newMessage,
          bot_uuid: botUid,
        })
        .then((response) => {
          addResponseMessage(response.data.answer);
          return response.data;
        })
        .then((data) => {
          setmessageText(data.did_text);
        })
        .then(() => {
          toggleMsgLoader();
        });
    } else {
      localStorage.setItem('customer-uuid', uuidv4());
      localStorage.setItem('avatar-customer-uuid', uuidv4());

      const custuuid = avatar
        ? localStorage.getItem('avatar-customer-uuid')
        : localStorage.getItem('customer-uuid');

      if (avatar) {
        setcustomerUuid(localStorage.getItem('avatar-customer-uuid'));
      } else {
        setcustomerUuid(localStorage.getItem('customer-uuid'));
      }

      axios
        .get(`${hostName}/api/widget/`, {
          params: {
            customer_uuid: custuuid,
            bot_uuid: botUid,
          },
        })
        .then((response) => {
          console.log(response);
          dropMessages();
          setChatHistory(response.data.messages);
          addResponseMessage(response.data?.start_message);
          return response.data;
        })
        .then(() => {
          toggleMsgLoader();
        });
    }
  };

  async function createStream(avatarImageUrl) {
    return fetch(`https://api.d-id.com/talks/streams`, {
      method: 'POST',
      headers: {
        Authorization: `Basic ${didToken}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        source_url: `${avatarImageUrl}`,
        compatibility_mode: 'on',
        config: { stitch: true },
      }),
    });
  }

  async function startStream() {
    return fetch(`https://api.d-id.com/talks/streams/${streamId}/sdp`, {
      method: 'POST',
      headers: {
        Authorization: `Basic ${didToken}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        answer: sessionClientAnswer,
        session_id: sessionId,
      }),
    });
  }
  async function createPeerConnection(offer, iceServers) {
    if (!peerConnection) {
      peerConnection = new RTCPeerConnection({ iceServers });
      peerConnection.addEventListener(
        'icegatheringstatechange',
        onIceGatheringStateChange,
        true
      );
      peerConnection.addEventListener('icecandidate', onIceCandidate, true);
      peerConnection.addEventListener(
        'iceconnectionstatechange',
        onIceConnectionStateChange,
        true
      );
      peerConnection.addEventListener(
        'connectionstatechange',
        onConnectionStateChange,
        true
      );
      peerConnection.addEventListener(
        'signalingstatechange',
        onSignalingStateChange,
        true
      );

      peerConnection.addEventListener('track', onTrack, true);
    }

    await peerConnection.setRemoteDescription(offer);
    console.log('set remote sdp OK');

    sessionClientAnswer = await peerConnection.createAnswer();
    console.log('create local sdp OK');

    await peerConnection.setLocalDescription(sessionClientAnswer);
    console.log('set local sdp OK');

    setPeer(peerConnection);
    return sessionClientAnswer;
  }

  function onIceCandidate(event) {
    console.log('onIceCandidate', event);
    if (event.candidate) {
      const { candidate, sdpMid, sdpMLineIndex } = event.candidate;

      fetch(`https://api.d-id.com/talks/streams/${streamId}/ice`, {
        method: 'POST',
        headers: {
          Authorization: `Basic ${didToken}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          candidate,
          sdpMid,
          sdpMLineIndex,
          session_id: sessionId,
        }),
      });
    }
  }

  function onIceGatheringStateChange() {
    console.log('onIceGatheringStateChange');
  }
  function onIceConnectionStateChange() {
    console.log(
      'onIceConnectionStateChange',
      peerConnection.iceConnectionState
    );
    if (
      peerConnection.iceConnectionState === 'failed' ||
      peerConnection.iceConnectionState === 'closed'
    ) {
      closePC();
    }
  }
  function onConnectionStateChange() {}
  function onSignalingStateChange() {
    console.log('onSignalingStateChange', peerConnection.signalingState);
  }

  function onVideoStatusChange(videoIsPlaying, stream) {
    console.log('onSignalingStateChange', videoIsPlaying, stream);
    if (videoIsPlaying) {
      setVideo(stream);
    } else {
      isTalk.current = false;
      setVideo(image);
    }
  }

  function onTrack(event) {
    if (!event.track) return;

    // peerConnection = peer;
    statsIntervalId = setInterval(async () => {
      if (
        peerConnection &&
        peerConnection.connectionState === 'connected' &&
        peerConnection.iceConnectionState === 'connected'
      ) {
        try {
          // await peerConnection.getTracks(event.track).forEach((report) => {console.log(report)})
          const stats = await peerConnection.getStats(event.track);
          stats.forEach((report) => {
            if (report.type === 'inbound-rtp' && report.mediaType === 'video') {
              const videoStatusChanged =
                videoIsPlaying !== report.bytesReceived > lastBytesReceived;

              if (videoStatusChanged) {
                videoIsPlaying = report.bytesReceived > lastBytesReceived;
                onVideoStatusChange(videoIsPlaying, event.streams[0]);
              }
              lastBytesReceived = report.bytesReceived;
            }
          });
        } catch (err) {}
      }
    }, 500);
  }

  async function prepare(avatarImageUrl) {
    if (isTalk.current) {
      return;
    }
    setFinishPrepare(false);
    // if (peerConnection && peerConnection.connectionState === 'connected') {
    //     if (
    //     peerConnection.iceConnectionState === 'connected' ||
    //     peerConnection.iceConnectionState === 'stable'
    //   ) {
    //       return;
    //     }
    // }
    closePC();

    const response = await createStream(avatarImageUrl);
    const {
      id: newStreamId,
      offer,
      ice_servers: iceServers,
      session_id: newSessionId,
    } = await response.json();
    streamId = newStreamId;
    setStrid(newStreamId);
    sessionId = newSessionId;
    setSessionid(newSessionId);

    try {
      sessionClientAnswer = await createPeerConnection(offer, iceServers); //.then(r => sessionClientAnswer = r);
    } catch (e) {
      console.log('error during streaming setup', e);
      closePC();
    }

    const startStreamResponse = await startStream();
    await startStreamResponse.json();
    setFinishPrepare(true);
  }

  useEffect(() => {
    if (finishPrepare && messageText) {
      playMessage(messageText);
    }
  }, [finishPrepare, messageText]);

  async function playMessage(text) {
    isTalk.current = true;
    peerConnection = peer;
    // connectionState not supported in firefox
    if (
      peerConnection?.signalingState === 'stable' ||
      peerConnection?.iceConnectionState === 'connected'
    ) {
      let data = {
        config: { stitch: true },
        script: {
          type: 'text',
          input: text,
          provider: {
            type: providerType,
            voice_id: providerVoiceId,
          },
          ssml: 'false',
        },
        session_id: sessionid,
      };
      if (providerStyle) {
        data['script']['provider']['voice_config'] = {
          style: providerStyle,
        };
      }

      const playResponse = await fetchWithRetries(
        `https://api.d-id.com/talks/streams/${strid}`,
        {
          method: 'POST',
          headers: {
            Authorization: `Basic ${didToken}`,
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(data),
        }
      );
    }
    setmessageText(null);
  }

  function closePC(pc = peerConnection) {
    if (!pc) return;
    console.log('stopping peer connection');
    pc.close();
    pc.removeEventListener(
      'icegatheringstatechange',
      onIceGatheringStateChange,
      true
    );
    pc.removeEventListener('icecandidate', onIceCandidate, true);
    pc.removeEventListener(
      'iceconnectionstatechange',
      onIceConnectionStateChange,
      true
    );
    pc.removeEventListener(
      'connectionstatechange',
      onConnectionStateChange,
      true
    );
    pc.removeEventListener(
      'signalingstatechange',
      onSignalingStateChange,
      true
    );
    pc.removeEventListener('track', onTrack, true);

    clearInterval(statsIntervalId);
    console.log('stopped peer connection');
    if (pc === peerConnection) {
      peerConnection = null;
    }
    setPeer(null);
    peerConnection = null;
  }
  async function fetchWithRetries(url, options, retries = 1) {
    try {
      return await fetch(url, options);
    } catch (err) {
      if (retries <= maxRetryCount) {
        const delay =
          Math.min(Math.pow(2, retries) / 4 + Math.random(), maxDelaySec) *
          1000;

        await new Promise((resolve) => setTimeout(resolve, delay));

        console.log(
          `Request failed, retrying ${retries}/${maxRetryCount}. Error ${err}`
        );
        return fetchWithRetries(url, options, retries + 1);
      } else {
        throw new Error(`Max retries exceeded. error: ${err}`);
      }
    }
  }

  function detectBrowser() {
    const userAgent = navigator.userAgent.toLowerCase();

    if (userAgent.indexOf('firefox') > -1) {
      return 'Firefox';
    } else if (userAgent.indexOf('chrome') > -1) {
      return 'Chrome';
    } else if (userAgent.indexOf('safari') > -1) {
      return 'Safari';
    } else if (
      userAgent.indexOf('opera') > -1 ||
      userAgent.indexOf('opr') > -1
    ) {
      return 'Opera';
    } else if (
      userAgent.indexOf('msie') > -1 ||
      userAgent.indexOf('trident') > -1
    ) {
      return 'Internet Explorer';
    } else {
      return 'Unknown';
    }
  }

  return (
    <div className="container">
      <div className="avatar">
        <img src={image} className="avatar-image" />
        <ReactPlayer
          style={{ zIndex: '1' }}
          url={video}
          width="100%"
          height="inherit"
          loop={loop}
          playing={play}
          onReady={() => setPlay(true)}
          onEnded={() => {
            if (video === animation) {
              setTimeout(() => {
                setPlay(true);
              }, 3000);
            } else {
              setVideo(animation);
              setLoop(true);
            }
          }}
        />
      </div>
      <div className="right">
        <Widget
          handleNewUserMessage={handleNewUserMessage}
          showTimeStamp={false}
          profileAvatar={logo}
          title={'Cleverbots Studio'}
          subtitle={'Online'}
          // emojis={true}
          showCloseButton={false}
          fullScreenMode={true}
          autofocus={false}
        />
        {/* <Recorder
          getHost={getHost}
          customerUuid={customerUuid}
          botUid={botUid}
          ava={ava}
          addResponseMessage={addResponseMessage}
          addUserMessage={addUserMessage}
          setmessageText={setmessageText}
        /> */}
      </div>
    </div>
  );
}

export default App;
